<template>
  <page>
  <v-expansion-panels v-model="panel1" multiple>
    <v-expansion-panel>
    <v-expansion-panel-header>
      <div>
        <v-icon>mdi-filter-variant</v-icon> Selection Criteria
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
    <v-card>
      <v-card-text>
        <form>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <cal-picker
                  v-model="form.fromDate"
                  :label="labels.fromDate"
                  v-validate="'required|start_after_today'"
                  :data-vv-as="labels.fromDate"
                  data-vv-name="fromDate"
                  :error-messages="errors.collect('fromDate')"
                ></cal-picker>
              </v-flex>
              <v-flex xs12 md6>
                <cal-picker
                  v-model="form.toDate"
                  :label="labels.toDate"
                  v-validate="toDateValidation(form.fromDate)"
                  :data-vv-as="labels.toDate"
                  data-vv-name="toDate"
                  :error-messages="errors.collect('toDate')"
                  :min="this.form.fromDate"
                ></cal-picker>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 lg12>
                <v-text-field readonly v-model="form.branch" :label="labels.branch" :error-messages="errors.collect('branch')"
                  data-vv-name="branch" :data-vv-as="labels.branch" append-icon="mdi-magnify" @click:append="multiBranchList = true"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 lg12>
                <v-text-field readonly v-model="form.department" :label="labels.department" :error-messages="errors.collect('dept')"
                  :data-vv-as="labels.department" data-vv-name="department" append-icon="mdi-magnify" @click:append="multiDeptList = true"></v-text-field>
              </v-flex>
            </v-layout>
            <!-- -->
            <v-layout row wrap>
              <v-flex xs12>
                <v-autocomplete
                  :label="labels.reportTypes"
                  :items="reportTypesList"
                  v-model="form.reportTypes"
                  item-text="value"
                  item-value="code"
                  data-vv-name="reportTypes"
                  :data-vv-as="labels.reportTypes"
                  :error-messages="errors.collect('reportTypes')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card-text>
    </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12 class="pt-3">
          <v-checkbox color="primary" :label="labels.rptParam" v-model="form.rptParam"></v-checkbox>
          <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
            {{ labels.export }}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="form.format">
            <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
              <span>{{ format.label }}</span>
              <v-icon :color="format.color">{{ format.icon }}</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>
      <v-dialog v-model="multiBranchList" width="900px" persistent>
        <multi-branch-help-list :brn="form.branch" @close="doClose" @doAssign="doAssignBranch($event)"></multi-branch-help-list>
      </v-dialog>

      <v-dialog v-model="multiDeptList" width="900px" persistent>
        <multi-dept-help-list :dept="form.department" @close="doClose" @doAssign="doAssignDepartment($event)"></multi-dept-help-list>
      </v-dialog>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import clone from 'clone'
import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList'
import MultiDeptHelpList from '@/components/core/common/dialog/MultiDeptHelpList.vue'
export default {
  data() {
    return {
      labels: {
        fromDate: 'Date From*',
        toDate: 'Date To*',
        branch: 'Branch',
        department: 'Department',
        format: 'Export Format',
        export: 'Export to',
        reportTypes: 'Type of Report',
        sendEmail: 'Send Output to Email',
        rptParam: 'Print Runtime Parameters'
      },
      form: {
        fromDate: '',
        toDate: '',
        branch: 'All',
        department: 'All',
        reportTypes: '1',
        format: 'PDF',
        sendEmail: false,
        rptParam: true
      },
      branchList: [],
      deptList: [],
      reportTypesList: [
        { code: '1', value: 'Accounts Transaction List' },
        { code: '2', value: 'RI Accounts Transaction List' },
        { code: '3', value: 'Payments & Receipts' },
        { code: '4', value: 'Debit & Credit Notes (Adjustment) List' },
        { code: '5', value: 'Accounts Transaction List (Sort By Transaction Type & Document No.)' }
      ],
      menu: {},
      supportedFormat: [],
      submitting: false,
      selectAllBrnMode: undefined,
      selectAllDeptMode: undefined,
      panel1: [0],
      multiBranchList: false,
      multiDeptList: false
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.accountReports.menu
    },
    usrId() {
      return this.$store.state.token.usrId
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  watch: {
    supportedList: function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.form.format = value[0].value
      }
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.accountReports.init !== 1) {
          await this.$store.dispatch('accountReportsInit')
        }
        const apiURI = this.rptMenu.acctTransaction
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
            if (this.menu) {
              this.doFetchBranch()
              this.doFetchDepartment()
              this.selectAllDeptMode = true
              this.selectAllBrnMode = true
            }
          }
        }
      } catch (err) {
        throw err
      }
    },
    toDateValidation(fromDate) {
      const result = 'required|start_after_today|from_to_date:' + fromDate
      return result
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          let clonedForm = clone(this.form)
          if (clonedForm.branch === 'All') {
            clonedForm.branch = 'allBrnSelected'
          }
          if (clonedForm.department === 'All') {
            clonedForm.department = 'allDeptSelected'
          }
          await this.$http.post(apiURI, clonedForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    getHelpList(fieldName) {
      this.mode = fieldName
      if (fieldName === 'branch') {
        this.apiURI = this.menu.getBranchList
        this.param = this.form.branch
        this.helplist = true
      }
    },
    doClose() {
      this.multiBranchList = false
      this.multiDeptList = false
    },
    doAssign(Obj) {
      if (this.mode === 'branch') {
        this.form.branch = ''
        this.form.branch = Obj.finalSelectedItems.toString()
      }
    },
    doAssignBranch(Obj) {
      this.form.branch = []
      this.form.branch = Obj.finalSelectedItems.toString()
    },
    async doAssignDepartment(Obj) {
      this.form.department = []
      this.form.department = Obj.finalSelectedItems.toString()
    }
  },
  created() {
    this.doInit()
    this.$validator.extend('start_after_today', {
      getMessage(field, args) {
        return `The ${field} cannot be later than the date of application.`
      },
      validate(value, args) {
        if (value) {
          const today = removeTime(new Date())
          const tomorrow = new Date(today)
          tomorrow.setDate(tomorrow.getDate() + 1)
          const startDate = removeTime(value)
          return isAfter(tomorrow, startDate)
        } else return true
      }
    })
  },
  mixins: [MessageMixin],
  components: {
    MultiBranchHelpList,
    MultiDeptHelpList
  }
}
</script>
